import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import SFToggleButton from "../toggleButton";

const SFToggleButtonGroup = forwardRef(
  ({ exclusive, value, onChange, spacing, buttonDefs, className }, ref) => {
    return (
      <ToggleButtonGroup
        ref={ref}
        exclusive={exclusive}
        value={value}
        onChange={onChange}
        spacing={spacing}
        className={className}
      >
        {buttonDefs.map((buttonDef, index) => (
          <SFToggleButton
            key={index}
            value={buttonDef.value}
            disabled={buttonDef.disabled}
            selected={value === buttonDef.value}
            onClick={buttonDef.onClick}
            ariaLabel={buttonDef.ariaLabel}
            className={buttonDef.className}
          >
            {buttonDef.label}
          </SFToggleButton>
        ))}
      </ToggleButtonGroup>
    );
  }
);

SFToggleButtonGroup.propTypes = {
  exclusive: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  spacing: PropTypes.number,
  className: PropTypes.string,
  buttonDefs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      className: PropTypes.string,
      ariaLabel: PropTypes.string,
      disabled: PropTypes.bool,
      label: PropTypes.node.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
};

export default SFToggleButtonGroup;
